module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic04.54c8721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic04.png
// module id = 522
// module chunks = 1